module.exports = __webpack_public_path__ + "media/src/images/zu_12question_application-a5e2fd781ddf7c8cca38ce01ba53f89e.png";